import React from 'react';
import HomeWorkProject from './project';
import { navigateTo } from 'gatsby-link';
//TO DO: GraphQL for list of projects
const HomeWork = () => {
    return (
        <section className="section-c section-6">
            <div className="section-title">
                <h2>My Work</h2>
            </div>
            <div className="section-wrapper">
                <h3>Take a look at some of my projects</h3>
                <div className="projects">
                    <HomeWorkProject src={require("../../../assets/img/projects/studysmart/mock.png")} alt="StudySmart" delay={0} title="StudySmart" to="/portofolio/studysmart"></HomeWorkProject>
                          <HomeWorkProject src={require("../../../assets/img/projects/laminardata/mock.jpg")} alt="Laminar Data" delay={150} title="Laminar" to="/portofolio/laminar"></HomeWorkProject>
                    <HomeWorkProject src={require("../../../assets/img/projects/tvshowtrack.jpg")} alt="TvShowTrack" delay={300} title="TvShowTrack" to="/portofolio/tst"></HomeWorkProject>
              
                </div>
                <div className="button-wrapper">
                    <button onClick={() => navigateTo('/portofolio')} className="animated  btn btn-primary hvr-grow-shadow">More Projects</button>
                </div>
            </div>
        </section>
    )
};

export default HomeWork;


// WEBPACK FOOTER //
// ./src/components/home/Work/index.js